import { Grid, Typography, withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Page, ScrollView } from 'react-layout-components';
import Waypoint from 'react-waypoint';
import Container from '../common/Container';
import Footer from '../common/Footer';
import HomeCard from '../common/HomeCard';
import Header from '../common/HomeHeader';
import ScrollDownFab from '../common/ScrollDownFab';
import Spacing from '../common/Spacing';
import {PLANS, SOLUTIONS} from '../pages/Solutions';
import Contact from './Contact';

const isPhone = window.innerWidth <= 480
const isMobile = window.innerWidth <= 1024

class Home extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            toolbarLight: false,
            cardsVisible: false,
            cardsVisible2: false,
        }
    }

    asyncSetState = (state) =>
        new Promise(a => requestAnimationFrame(() => this.setState({ ...this.state, ...state }, a)))

    handleScroll = (scrollTop) => {
        const toolbarLight = scrollTop > 80

        if (toolbarLight !== this.state.toolbarLight)
            this.asyncSetState({ toolbarLight: scrollTop > 80 })
    }

    doShowCards = () => this.asyncSetState({ cardsVisible: true })
    doShowCards2 = () => this.asyncSetState({ cardsVisible2: true })
    doHideCards = () => this.asyncSetState({ cardsVisible: false })
    doHideCards2 = () => this.asyncSetState({ cardsVisible2: false })

    render() {

        const { classes } = this.props

        return (
            <Page>
                <ScrollView height="100%"
                    id="scroll"
                    onScroll={this.handleScroll}>
                    <div>
                        <Header lightToolbar={this.state.toolbarLight} />
                        <Waypoint
                            key={'cards-way-point'}
                            onEnter={this.doShowCards}
                            onLeave={this.doHideCards}
                            topOffset={-300}
                            bottomOffset={300}>
                            <div>
                                <Container>
                                    <Box className={classes.content} column center>

                                        <Box center column>
                                            <ScrollDownFab />
                                            <Spacing vertical large />
                                            <Typography className={classes.sectionTitle}>
                                                Nossas Soluções
                                            </Typography>
                                        </Box>

                                        <Spacing vertical large />

                                        <Grid container className={classes.root} spacing={32}>
                                            {
                                                SOLUTIONS.map(({ title, shortDescription, image, key, link }, i) => (
                                                    <Grid key={key} item xs={12} sm={6} md={4} lg={4}>
                                                        <HomeCard title={title}
                                                            index={i}
                                                            visible={this.state.cardsVisible}
                                                            description={shortDescription} image={image}
                                                            link={link} />
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>

                                    </Box>
                                </Container>
                            </div>
                        </Waypoint>


                        <Waypoint
                            key={'cards-way-point-2'}
                            onEnter={this.doShowCards2}
                            onLeave={this.doHideCards2}
                            topOffset={-300}
                            bottomOffset={300}>
                            <div>
                                <Container>
                                    <Box className={classes.content} column center>

                                        <Box center column>
                                            <Spacing vertical large />
                                            <Typography className={classes.sectionTitle}>
                                                Conheça nossos planos
                                            </Typography>
                                        </Box>

                                        <Spacing vertical large />

                                        <Grid container className={classes.root} spacing={32}>
                                            {
                                                PLANS.map(({ title, shortDescription, image, key, link }, i) => (
                                                    <Grid key={key} item xs={12} sm={6} md={4} lg={4}>
                                                        <HomeCard title={title}
                                                                  index={i}
                                                                  visible={this.state.cardsVisible2}
                                                                  description={shortDescription} image={image}
                                                                  link={link} />
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>

                                    </Box>
                                </Container>
                            </div>
                        </Waypoint>

                        <Spacing vertical large />
                        <Spacing vertical large />
                        <Spacing vertical large />

                        <Box className={classes.darkBg}>
                            <Container>

                                <Box justifyContent="space-between" width="100%" center column={isPhone}>

                                    <Box column id="about" width="100%" center>

                                        <Typography className={classes.sectionTitleLight}
                                                    variant={'title'} paragraph align="center">
                                            Veja a opinião dos nossos clientes
                                        </Typography>

                                        <Spacing vertical large />

                                        <img
                                            width="192"
                                            height="192"
                                            src={'/images/luana.png'}/>

                                        <Spacing vertical />

                                        <Typography variant={'body1'} paragraph align="center"
                                                    style={{fontWeight: '400', fontFamily: 'Montserrat', color: 'white'}}>
                                            Luana
                                        </Typography>
                                        <Typography variant={'body1'} paragraph align="center"
                                                    style={{fontWeight: '400', fontFamily: 'Montserrat', color: 'white'}}>
                                            Co-fundadora da empresa
                                        </Typography>
                                        <Typography variant={'body1'} paragraph align="center"
                                                    style={{fontWeight: '700', fontFamily: 'Montserrat', color: 'white'}}>
                                            New Way Qualificações
                                        </Typography>

                                        <Spacing vertical large />

                                        <Typography
                                            className={classes.aboutText}
                                            variant={'body1'}
                                            paragraph align={'center'}
                                            style={{fontWeight: '400', fontFamily: 'Montserrat', color: 'white'}}>

                                            "A <b>Cytech</b> colocou a New Way de vez nas redes sociais, e isso foi
                                            essencial para o sucesso dos nossos novos cursos! Além de terem uma
                                            equipe muito atenciosa. Recomendo!"

                                        </Typography>

                                    </Box>
                                </Box>
                            </Container>

                            <img src="/images/mountain-bottom-grey.svg" className={classes.darkBgBottom} />
                        </Box>

                        <Container>
                            <Box className={classes.content} column center id="about">

                                <Contact />

                            </Box>
                        </Container>

                        <Footer />
                    </div>
                </ScrollView>
            </Page>
        )
    }

}

Home.propTypes = {
    classes: PropTypes.any,
}

Home.defaultProps = {

}

const styles = theme => ({
    content: {
        width: '100%',
        paddingBottom: 56 + 16
    },
    darkBg: {
        backgroundColor: theme.palette.primary.main,
        paddingTop: 64,
        paddingBottom: 64 + 128,
        position: 'relative'
    },
    darkBgBottom: {
        position: 'absolute',
        bottom: -2,
        width: '100%'
    },
    aboutLogo: {
        width: 240,
    },
    aboutText: {
        maxWidth: 480,
        fontSize: 18,
        letterSpacing: 1.1,
        lineHeight: 1.3,
        fontWeight: 500,
        color: '#FFF',
        opacity: .9
    },
    lightTitle: {
        fontSize: 24,
        color: '#FFF'
    },
    sectionTitle: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 20,
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 24
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 28
        },
        fontWeight: '700',
        margin: 0,
        letterSpacing: 1.1,
        lineHeight: 1.3,
        fontFamily: 'Montserrat',
        color: theme.palette.primary.main
    },
    sectionTitleLight: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 20,
            textAlign: 'center'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: 24
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: 28
        },
        fontWeight: '700',
        margin: 0,
        letterSpacing: 1.1,
        lineHeight: 1.3,
        fontFamily: 'Montserrat',
        color: theme.palette.white
    }
})

export default withTheme()(withStyles(styles)(Home))


// WEBPACK FOOTER //
// ./src/components/pages/Home.js